import React, { useState } from 'react';
import { OpenInNew, Send } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Menu, MenuItem } from '@upstart/shared-components';
import { Origin } from '@upstart/harmony/lib/constants';

import Tooltip from 'components/Tooltip';
import InstoreService from '../../../services/InstoreService';
import { SendButtonProps } from './types';

import './PresentToCustomerMenuButton.scss';
import { sendData } from '../../../util/amplitude';
import { amplitudeEventsDeskingCTR } from '../../../util/amplitudeEvents';

const UPDATE_DEAL = 'Update Deal';
const PRESENT_OFFERS = 'Present Offers';
const PRESENT_TO_CUSTOMER = 'Present to customer';
const SEND_TO_SALESPERSON = 'Send to salesperson';

const PresentToCustomerMenuButton = React.memo((props: SendButtonProps) => {
  const {
    dealId,
    disabled,
    lastOpenedInStore,
    onSubmit,
    origin,
    tooltip,
  } = props;
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const isOnlineAndNotOpenedInStore =
    origin === Origin.ONLINE && !lastOpenedInStore;
  const btnText = isOnlineAndNotOpenedInStore ? UPDATE_DEAL : PRESENT_OFFERS;

  const onOpenHandler = (event: React.MouseEvent): void => {
    setAnchorEl(event.currentTarget);
  };
  const onCloseHandler = (): void => {
    setAnchorEl(null);
  };

  const presentToCustomerMenuItem = (
    <MenuItem
      data-testid="present-to-customer-menu-item"
      onClick={() => {
        sendData(amplitudeEventsDeskingCTR.DESKING_PRESENTED_TO_CUSTOMER, {
          fniPresentFlow: true,
          dealId,
        });
        onSubmit(); // send selected products to salesperson
        window.open(InstoreService.getInstoreFinanceOffersUrl(dealId));
        onCloseHandler();
      }}
    >
      <div className="dropdown-menu-item">
        <OpenInNew />
        {PRESENT_TO_CUSTOMER}
      </div>
    </MenuItem>
  );

  const sendToSalespersonMenuItem = (
    <MenuItem
      data-testid="send-to-salesperson-menu-item"
      onClick={() => {
        sendData(amplitudeEventsDeskingCTR.DESKING_SENT_TO_SALESPERSON, {
          fniPresentFlow: true,
          dealId,
        });
        onSubmit();
        onCloseHandler();
      }}
    >
      <div className="dropdown-menu-item">
        <Send />
        {SEND_TO_SALESPERSON}
      </div>
    </MenuItem>
  );

  return (
    <>
      <button
        className="send-pencil-button"
        data-testid="send-button-v2"
        type="button"
        disabled={disabled}
        onClick={onOpenHandler}
      >
        {tooltip ? <Tooltip text={tooltip}>{btnText}</Tooltip> : btnText}
        <ExpandMoreIcon />
      </button>
      <Menu
        data-testid="send-button-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={onCloseHandler}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        invisibleBackdrop
      >
        {presentToCustomerMenuItem}
        {sendToSalespersonMenuItem}
      </Menu>
    </>
  );
});

export default PresentToCustomerMenuButton;
